import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoRobot16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M5.78947 7.25C5.78947 7.45708 5.62452 7.625 5.42105 7.625C5.21758 7.625 5.05263 7.45708 5.05263 7.25M5.78947 7.25C5.78947 7.04289 5.62452 6.875 5.42105 6.875C5.21758 6.875 5.05263 7.04289 5.05263 7.25M5.78947 7.25H5.05263M10.9474 7.25C10.9474 7.45708 10.7824 7.625 10.5789 7.625C10.3755 7.625 10.2105 7.45708 10.2105 7.25M10.9474 7.25C10.9474 7.04289 10.7824 6.875 10.5789 6.875C10.3755 6.875 10.2105 7.04289 10.2105 7.25M10.9474 7.25H10.2105M8 3.5V2M1.73684 6.5C1.3299 6.5 1 6.83579 1 7.25C1 7.66422 1.3299 8 1.73684 8M14.2632 6.5C14.6701 6.5 15 6.83579 15 7.25C15 7.66422 14.6701 8 14.2632 8M6.52632 10.625H9.47368M1.73684 11.75V5C1.73684 4.17157 2.39663 3.5 3.21053 3.5H12.7895C13.6034 3.5 14.2632 4.17157 14.2632 5V11.75C14.2632 12.9927 13.2735 14 12.0526 14H3.94737C2.72653 14 1.73684 12.9927 1.73684 11.75Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoRobot16;